import(/* webpackMode: "eager" */ "D:\\a\\1\\s\\shesha-functional-tests\\adminportal\\src\\app\\configuration-studio\\page.tsx");
